export default __webpack_public_path__ + "static/media/emp-dir.2189feeb.png";